import { render, staticRenderFns } from "./redpacket_goods.vue?vue&type=template&id=02205a9e"
import script from "./redpacket_goods.vue?vue&type=script&lang=ts"
export * from "./redpacket_goods.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports